import { trackEvent } from '@/utils/mixpanel';

/**
 * Track a "Download All" action on any photodrop page.
 * @param {string} pageUrl - Current route path (this.$route.path)
 * @param {string} photoSection - e.g. 'for_everyone'
 * @param {number} fileQuantity - Number of photos being downloaded
 */
export function trackPhotodropDownloadAll(pageUrl, photoSection, fileQuantity) {
  trackEvent('Photodrop Download All', {
    page_url: pageUrl,
    photo_section: photoSection,
    file_quantity: fileQuantity,
    page: 'photodrop',
  });
}

/**
 * Track a bulk download (direct or email) on any photodrop page.
 * @param {string} pageUrl - Current route path (this.$route.path)
 * @param {'direct'|'email'} downloadType - How the download was triggered
 * @param {number} fileQuantity - Number of files selected
 * @param {string} photoSection - e.g. 'for_everyone' or 'my_photos'
 */
export function trackPhotodropBulkDownload(pageUrl, downloadType, fileQuantity, photoSection) {
  trackEvent('Photodrop Bulk Download', {
    page_url: pageUrl,
    download_type: downloadType,
    file_quantity: fileQuantity,
    photo_section: photoSection,
    page: 'photodrop',
  });
}

/**
 * Track a single file download on any photodrop page.
 * @param {string} fileName - File name (pathname from URL)
 * @param {'single'|'long_press_single'|'email'} downloadType - How the download was triggered
 * @param {string} pageUrl - Current route path (this.$route.path)
 */
export function trackPhotodropIndividualDownload(fileName, downloadType, pageUrl) {
  trackEvent('Photodrop Individual File Downloaded', {
    file_name: fileName,
    download_type: downloadType,
    page_url: pageUrl,
    page: 'photodrop',
  });
}
